// extracted by mini-css-extract-plugin
export var active = "_ch-2";
export var recordingDot = "_ch-1";
export var recordingIndicator = "_ch-0";